import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { PRIZES } from '../constants'

const deletePrize = async (id: number) => {
  await fetchAPI({
    path: `/prize_exchanges/${id}`,
    method: 'delete',
  })
}

export const useDeletePrize = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(deletePrize, {
    async onSuccess() {
      await queryClient.refetchQueries([PRIZES])

      toast({
        description: t('views.admin.prize_exchanges.services.delete_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
